import styled from 'styled-components';

export const StyledContent = styled('div')`
  width: 95%;
  margin: auto;
  .ant-form-item-control-input {
    width: 350px;
  }
`;
